import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

// En dev sur localhost : désenregistrer tout Service Worker restant pour éviter le cache
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister())
    if (regs.length) console.log('Service Worker(s) désenregistré(s) pour le dev')
  })
}

// Enregistrer le Service Worker uniquement en PRODUCTION (évite le cache en dev sur localhost:3000)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        setInterval(() => registration.update(), 60000)
      })
      .catch(() => {
        /* l'application fonctionne sans Service Worker */
      })
  })
}

// Obtenir l'élément root
const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Élément root introuvable')
}

// Créer le root React et rendre l'application
try {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  )
} catch (error) {
  console.error('Erreur lors du montage de React:', error)

  // Dernier filet de sécurité : React n'a pas pu monter, donc aucun composant
  // n'est disponible. Cet écran est écrit à la main, mais il puise dans les
  // mêmes variables de thème que le reste de l'application — avec des valeurs
  // de repli au cas où la feuille de styles elle-même n'aurait pas chargé.
  rootElement.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:16px;
                background:var(--canvas,#f7f8fa);
                font-family:Inter,ui-sans-serif,system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;">
      <div style="width:100%;max-width:28rem;border:1px solid var(--border,#e4e7ec);border-radius:12px;
                  background:var(--surface,#fff);padding:24px;">
        <div style="display:flex;height:40px;width:40px;align-items:center;justify-content:center;
                    border-radius:9999px;background:var(--negative-subtle,#fef3f2);color:var(--negative,#d92d20);
                    margin-bottom:16px;">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
               stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.7 4.1 2.6 17.6a1.5 1.5 0 0 0 1.3 2.3h16.2a1.5 1.5 0 0 0 1.3-2.3L13.3 4.1a1.5 1.5 0 0 0-2.6 0Z"/>
            <path d="M12 9.5v4M12 17h.01"/>
          </svg>
        </div>
        <h1 style="margin:0;font-size:20px;font-weight:600;letter-spacing:-0.014em;color:var(--text,#0a0f1c);">
          L’application n’a pas pu démarrer
        </h1>
        <p style="margin:6px 0 0;font-size:14px;line-height:1.4;color:var(--text-secondary,#475467);">
          Recharger la page suffit le plus souvent à repartir.
        </p>
        <details style="margin-top:16px;">
          <summary style="cursor:pointer;font-size:13px;color:var(--text-muted,#697586);">
            Détails techniques
          </summary>
          <pre style="margin:8px 0 0;max-height:12rem;overflow:auto;border:1px solid var(--border,#e4e7ec);
                      border-radius:6px;background:var(--surface-sunken,#f2f4f7);padding:12px;font-size:12px;
                      color:var(--text-secondary,#475467);white-space:pre-wrap;">${error.message}\n${error.stack || ''}</pre>
        </details>
        <button onclick="window.location.reload()"
                style="margin-top:20px;width:100%;border:0;border-radius:8px;padding:10px 14px;
                       background:var(--accent,#1b4dff);color:var(--accent-contrast,#fff);
                       font-size:14px;font-weight:500;font-family:inherit;cursor:pointer;">
          Recharger la page
        </button>
      </div>
    </div>
  `
}
